export default __webpack_public_path__ + "static/media/section3-icon1.5f98db93.png";